<template>
  <div v-if="show.online && !show.live && step === 1" class="show-date-box">
    <div class="show-dates active">
      <button type="button" @click="finish(show.dates[0])" class="show-date-buy">Comprar</button>
      <div class="info">Disponível por 7 dias</div>
    </div>
  </div>
  <div v-else-if="show.online && !show.live && step > 1" style="border-bottom: 1px solid #d5d5d5; width: 100%; margin: 15px 0; padding: 10px 0;"></div>
  <div v-else class="show-date-box">
    <div @click="setStep(1)" class="show-date-text">
      <div :class="{ 'show-date-select' : step == 1, 'stage-text' : step > 1 }">{{ step > 1 ? 'Data(s) e descrição do evento' : 'Selecione a data e compre seu ingresso' }}:</div>
      <div v-if="step > 1">{{ formatDate(showDate.date) }}</div>
      <i v-if="step > 1" class="show-date-toggle fas" :class="step === 1 ? 'fa-angle-up' : 'fa-angle-down'"></i>
    </div>
    <div class="show-dates" :class="{ active : step === 1 }">
      <div v-for="showD in show.dates" @click="finish(showD)" :key="showD.id" class="show-date" :class="{ disabled : showDate && showD.id === showDate.id}">
        <span>{{ getDay(showD.date) }}</span>
        <span>{{ getMonthText(showD.date) }}</span>
        <span>{{ getHours(showD.date) + ':' + getMinutes(showD.date) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getOnlineShows } from '../api/showDate'
import logger from '../../logger'

export default {
  name: 'showDate',
  props: ['step', 'setStep', 'show', 'showDate', 'finishDate'],
  computed: {
    ...mapState(['user'])
  },
  methods: {
    async finish (date) {
      try {
        if (this.show.online && !this.user) {
          this.$store.commit('showLogin', true)
          return false
        } else if (this.show.online) {
          const shows = await getOnlineShows()
          if (shows.find(x => x.id === date.id)) {
            this.$router.push('/usuario')
            this.$message.success('Você já realizou a compra desse evento.', { duration: 3000 })
            return false
          }
        }
        this.finishDate(date)
      } catch (error) {
        logger.error(error, this)
      }
    },
    formatDate (date) {
      let text = this.getDay(date) + ' de '
      text += this.getMonthTextFull(date)
      text += ' às '
      text += this.getHours(date)
      text += ':'
      text += this.getMinutes(date)
      return text
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.show-date-box {
  width: 100%;
  margin: 15px 0;
  padding: 10px 0;
  border-top: 1px solid #d5d5d5;
  border-bottom: 1px solid #d5d5d5;
}
.show-date-select {
  font-weight: 400;
  font-size: 1.4em;
}

.show-dates {
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  max-height: 0;
  visibility: hidden;
  opacity: 0;
  transition: max-height 0.5s, visibility 0.5s, opacity 0.3s;
  margin: 0 -5px;
  padding: 0 5px;
  &.active {
    visibility: visible;
    opacity: 1;
    max-height: 1000px;
  }
  div:nth-child(1) {
    margin-left: 0;
  }
  div:last-child {
    margin-right: 0;
  }
  .info {
    color: #333;
    font-size: 1em;
    font-weight: 300;
    margin-left: 15px;
  }
}

.show-date-text {
  display: flex;
  align-items: center;
  width: 100%;
  color: #333;
  font-size: 1em;
  font-weight: 300;
  padding: 5px 0;
  div:nth-child(2) {
    color: $primary-color;
    font-size: 1.1em;
    font-weight: 500;
    margin-left: 10px;
  }
}

.show-date-toggle {
  flex: 1;
  text-align: right;
  cursor: pointer;
  font-size: 1.6em;
  color: #999;
}

.show-date {
  width: 65px;
  height: 70px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin: 5px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;

  &.disabled {
    opacity: 0.3;
  }

  &:hover {
    box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.2);
    transform: scale(1.05);
  }

  span:nth-child(1) {
    color: $primary-color;
    font-weight: 400;
    font-size: 1.6em;
    padding-top: 2px;
  }

  span:nth-child(2) {
    color: $primary-color;
    font-weight: 500;
    font-size: 0.8em;
    margin-top: -8px;
  }

  span:nth-child(3) {
    width: 100%;
    text-align: center;
    font-size: 1em;
    padding: 5px 0;
    color: #fff;
    background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
    border-radius: 0 0 5px 5px;
  }
}

.show-date-buy {
  color: #fff;
  border: none;
  border: 1px solid $primary-color;
  border-radius: 5px;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  font-size: 1.2em;
  padding: 10px 25px;
  text-transform: uppercase;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
}
</style>
